import React, { useEffect, useState } from "react"
import Login from "./components/Login/Login"
import { Routes, Route } from "react-router-dom"
import Home from "./components/Home/Home"

export interface UserInterface {
    _id: string
    authToken: string
    files?: any[]
    name: string
    email: string
    managing: string[]
    success: boolean
    rootFolderId?: any
    orgs: string[]
    activeOrgId?: string
}

const App: React.FC = () => {
    const [user, setUser] = useState<UserInterface>({} as UserInterface)
    const [entryType, setEntryType] = useState<"login" | "register">("login")

    useEffect(() => {
        if (user.success) {
            window.location.href = "#/"
            localStorage.setItem("credentials", JSON.stringify(user))
        }
    }, [user])

    useEffect(() => {
        const credentials = localStorage.getItem("credentials")
        if (credentials) {
            const parsedCredentials = JSON.parse(credentials)
            setUser(parsedCredentials)
        }

        if (!user.name || !user.rootFolderId) {
            window.location.href = "#/login"
        }
    }, [])

    return (
        <Routes>
            <Route path="/" element={<Home setUser={setUser} user={user} />} />
            <Route
                path="/login"
                element={
                    <Login setUser={setUser} entryType={entryType} setEntryType={setEntryType} />
                }
            />
        </Routes>
    )
}

export default App
